import React from 'react';
import { Button } from './ui/Button';
interface BeforeAfterProps {
  onBookConsultation?: () => void;
}
export function BeforeAfter({
  onBookConsultation
}: BeforeAfterProps) {
  const cases = [{
    id: 1,
    patient: 'Female, 42 — After 4 Sessions',
    location: 'San Ramon, CA',
    image: 'https://cdn.magicpatterns.com/uploads/77LqyVqtnn2WNi8YqThFLA/prpscalp1.jpg'
  }, {
    id: 2,
    patient: 'Female, 38 — After 3 Sessions',
    location: 'Danville, CA',
    image: 'https://cdn.magicpatterns.com/uploads/fY271LKjFwkfR7ZRoYYoGY/prpscalp0.jpg'
  }, {
    id: 3,
    patient: 'Age 55 — After 5 Sessions',
    location: 'Pleasanton, CA',
    image: 'https://cdn.magicpatterns.com/uploads/aLJWNcjSVJyJW4BEYeso8e/prp2.jpg'
  }];
  return <section className="bg-white py-20 md:py-32 px-4 border-t border-divider" data-id="element-1">
      <div className="max-w-7xl mx-auto" data-id="element-2">
        <h2 className="font-serif text-3xl md:text-5xl text-espresso text-center mb-16" data-id="element-3">
          Real Results
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-4">
          {cases.map(item => <div key={item.id} className="flex flex-col" data-id="element-5">
              <div className="relative rounded-sm overflow-hidden mb-6 group" data-id="element-6">
                <img src={item.image} alt={`Before and after hair restoration treatment - ${item.patient}`} className="w-full h-auto object-cover" data-id="element-7" />
                <div className="absolute bottom-0 inset-x-0 flex" data-id="element-8">
                  <div className="flex-1 flex justify-center py-2 bg-black/40 backdrop-blur-sm" data-id="element-9">
                    <span className="text-xs font-sans uppercase tracking-wider text-white" data-id="element-10">
                      Before
                    </span>
                  </div>
                  <div className="flex-1 flex justify-center py-2 bg-black/40 backdrop-blur-sm" data-id="element-11">
                    <span className="text-xs font-sans uppercase tracking-wider text-white" data-id="element-12">
                      After
                    </span>
                  </div>
                </div>
              </div>

              <div className="text-center" data-id="element-13">
                <p className="font-sans font-medium text-espresso text-lg" data-id="element-14">
                  {item.patient}
                </p>
                <p className="font-sans text-sm text-muted-foreground mt-1" data-id="element-15">
                  {item.location}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-16 flex justify-center" data-id="element-16">
          <Button onClick={onBookConsultation} variant="primary" data-id="element-17">
            Book A Consultation
          </Button>
        </div>
      </div>
    </section>;
}